<template>
    <div class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header :header-type="'shop'"></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <!-- 상품 리스트 -->
            <section class="product-lists">
                <div class="inner">
                    <!-- 상품 리스트 시작 -->
                    <div class="center-title">
                        <h2>새집처럼 <b>핫딜</b></h2>
                        <div class="lists-option">
                            <select class="select select--orange select--underline">
                                <option value="">인기순</option>
                            </select>
                        </div>
                    </div>
                    <div class="product-lists__body">
                        <div class="grid">
                            <div v-for="{ product } in exhibitions" :key="product._id" class="grid-6">
                                <router-link class="product-list" :to="`/shop/products/${product._id}`">
                                    <span class="product-list__thumb">
                                        <span class="product-list__thumbnail">
                                            <span class="product-list__thumbnail-image" :style="{ backgroundImage: `url('${product.thumb}')` }"></span>
                                        </span>
                                        <span class="product-list__thumb-image"></span>
                                    </span>
                                    <span class="product-list__badge product-list__badge--small" v-if="product.discountRemainingTime">{{ remaining(product.discountRemainingTime) }}</span>
                                    <span class="product-list__brand">{{ (product.user || {}).name }}</span>
                                    <span class="product-list__title">{{ product.name }}</span>
                                    <span class="product-list__price">
                                        <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.discountRate }}%</span>
                                        <em class="product-list__price-num">{{ product.salePrice.format() }}원</em>
                                        <span v-if="product.discountEnabled" class="product-list__price-line">{{ product.price.format() }}</span>
                                    </span>
                                </router-link>
                            </div>
                        </div>

                        <div class="product-lists__pagination">
                            <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component>
                        </div>
                        <!-- <div class="bottom-button">
							<a href="#" class="button button--orange button--border" onclick="event.preventDefault()">더보기</a>
						</div> -->
                    </div>
                </div>
            </section>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        PaginationComponent,
    },
    data() {
        return {
            filter: {
                code: "special",
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,

            count: 0,

            exhibitions: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search(false);
        },
        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, { page: this.page }),
                    });
                }

                var { summary, exhibitions } = await api.v1.shop.exhibitions.getExhibitions({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.exhibitions = exhibitions;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
                this.setTimer();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        setTimer() {
            setTimeout(() => {
                this.count += 1000;
                this.setTimer();
            }, 1000);
        },
        remaining(time) {
            var now = (time - this.count) / 1000;
            if (!now || now < 0) return 0;
            else if (!Math.floor(now / 86400)) {
                var mod = now % 86400;
                var hours = Math.floor(mod / 3600);
                var minutes = Math.floor((mod % 3600) / 60);
                var seconds = Math.floor((mod % 3600) % 60);
                return [hours, minutes, seconds].map((item) => item.toString().padStart(2, "0")).join(":");
            } else {
                return `D-${Math.floor(now / 86400)}`;
            }
        },
    },
};
</script>
